import React from "react";


export const Footer =() => {
  const today = new Date();
  const year = today.getFullYear();

  const version =  '1.0.0';
  const copyrigth =  `Copyright © `;

  return (
    <footer className="main-footer">
      <strong>
        {copyrigth} {year} <span className="text-danger">LG Portal </span>.
      </strong>
      All rights reserved.
      <div className="float-right d-none d-sm-inline-block">
        <b>Version</b> {version}
      </div>
    </footer>
  )
}
